export default __webpack_public_path__ + "static/kasa_1-ff85524d64f5976007c62978626bf0ad.png";